import styled from 'styled-components';
import { Jumbotron, Col, Container } from 'reactstrap';

import { lighterGrey } from '../../styles/styled/colors';
import img from './banner.svg';
import Dropdown from '../../components/Dropdown/Dropdown';

export const Wrapper = styled(Container)`
    min-width: 992px;
`;

export const InputWrapper = styled.div`
    border-bottom: 3px solid ${lighterGrey};
    margin-bottom: 45px;
`

export const JsonViewerWrapper = styled.div`
    background: black;
    min-height: 860px;
`

export const JumbotronWithImage = styled(Jumbotron)`
    background-image: url(${img});
    background-size: cover;
    margin-bottom: 0;
`

export const RelationshipWrapper = styled.div`
    display: inline-flex;
    width: 100%;
`

export const RelationshipIcon = styled.div`
    visibility: ${props => props.showArrow ? 'visible' : 'hidden'};
`

export const AddRelationship = styled.div`
    padding-left : 80px;
`

export const GreyCol = styled(Col)`
    background: ${lighterGrey};
    padding-right: 0px;
    min-width: 140px;
`

export const ExampleDropdown = styled(Dropdown)`
    padding-top: 11px;
    border: 0px;
    background: ${lighterGrey};

    .dropdown-select {
        padding-top: 1px;
        padding-left: 8px;
        padding-right: 8px;
        font-size: 14px;
        border: 0px;
        background: ${lighterGrey};
    }

    img {
        margin-top: 3px;
    }

    .option-wrapper {
        width: 200px;
        margin-top: 8px;
        padding-left: 8px;
    }

    p {
        padding-top: 0px;
    }
`
export const AliasAttributeWrapper = styled.div`
    margin-top : 45px;
`

export const DeleteRelationshipWrapper = styled(Col)`
    padding-top: 3px;
`



// WEBPACK FOOTER //
// ./src/containers/TqlBuilder/Styled.js